<a class="powered-by" href="https://www.i4life.es" target="_blank" rel="noopener" [attr.aria-label]="text + ' i4life'">
  <span class="text" aria-hidden="true">
    @for (letter of letters; track $index) {
      <span class="letter" [style.animation-delay.s]="$index * 0.05">{{ letter }}</span>
    }
  </span>
  @if (logo) {
    <img
      class="logo letter"
      [style.animation-delay.s]="(letters.length + 1) * 0.05"
      src="assets/images/logo_i4life.svg"
      alt="i4life"
    />
  }
</a>
